<template>
  <div>
    <v-card color="grey lighten-4">
      <Snackbar :SnackbarVal="SnackbarVal"></Snackbar>
    </v-card>
    <v-container>
      <!-- Form -->
      <v-card>
        <v-card-title>
          <span class="headline">{{ formTitle }}</span>
        </v-card-title>
        <v-form v-model="valid" ref="form" lazy-validation>
          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12 sm4 md4>
                  <!-- <v-text-field label="Gross" v-model="formSchema.gross" :rules="[v => !!v || 'Field is required']" required></v-text-field> -->
                  <!-- <YearPicker :label="label" @setYear="setYear" :year.sync='year'></YearPicker> -->
                  <v-select
                  :items="yearList"
                  label="Year"
                  item-text="name"
                  item-value="year"
                  hide-details
                  v-model="year"
                  @change="getCheck"
                  ></v-select>
                </v-flex>

                <v-flex xs12 sm4 md4>
                  <v-select
                    :items="months"
                    label="Month"
                    item-value="text"
                    hide-details
                    v-model="month"
                    @change="getCheck"
                  ></v-select>
                </v-flex>
              </v-layout>
              <br><br>
              <v-layout wrap>
                
                <table
                  id = "mytable"
                  :class="['table table-border table-responsive']"
                  width="100%"
                  v-show="isVisible"
                >
                  <thead>
                    <th width="5%" class="text-left">Sl</th>
                    <th width="12%" class="text-left">Staff ID</th>
                    <th width="12%" class="text-left">Name</th>
                    <th width="12%" class="text-left">Days</th>
                    <th width="16%" class="text-left">Overtime (Hour)</th>
                    <th width="17%" class="text-left">Overtime Rate (BDT/Hour)</th>
                    <th width="17%" class="text-left">Total</th>
                    <th width="16%" class="text-right">Action</th>
                  </thead>
                  <tr v-for="(val, index) in staffData" :key="index">
                    <td>{{slNo(index)}}</td>
                    <td>    
                      {{ val.staff_id }}                 
                     <input type="hidden" v-model="formSchema[index].staff_id" /> 
                                      
                    </td>
                    <td>{{ formSchema[index].staff_name }}
                     <input type="hidden" v-model="formSchema[index].staff_name" /> 
                    </td>
                    <td>                      
                      <v-text-field
                        label="days"
                        v-model="formSchema[index].days"
                        :rules="(formSchema[index].isCheck) ? numberRules: []"   
                        :readonly="!formSchema[index].isCheck"                     
                      ></v-text-field>
                    </td>
                    <td>                      
                      <v-text-field
                        label="Overtime"
                        v-model="formSchema[index].overtime"
                        @input="calculateTotal(index)"
                        :rules="(formSchema[index].isCheck) ? numberRules: []"   
                        :readonly="!formSchema[index].isCheck"                     
                      ></v-text-field>
                    </td>
                    <td>
                      <v-text-field
                        v-model="formSchema[index].rate"
                        label="Overtime Rate"                                                
                        @input="calculateTotal(index)"
                        :rules="(formSchema[index].isCheck) ? numberRules: []"
                        :readonly="!formSchema[index].isCheck"
                      ></v-text-field>
                    </td>
                    <td>
                      <v-text-field
                        label="Total"
                        v-model="formSchema[index].total"   
                        readonly                     
                      ></v-text-field>
                    </td>
                    <td style="text-align:center">                      
                      <v-checkbox class="mx-2" v-model="formSchema[index].isCheck" @change="checkIndex($event, index)"></v-checkbox>
                    </td>
                  </tr>
                  <tr v-if="staffData.length == 0">
                    <td colspan="19">No Data Found</td>
                  </tr>
                </table>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="success"
              @click.native="validateBeforeSubmit"
              >{{btnTitle}}</v-btn
            >
            <v-btn color="error" @click.native="reset">Reset</v-btn>

          </v-card-actions>
        </v-form>
      </v-card>
      <!-- /Form -->
    </v-container>
  </div>
</template>
<script>
/**
 * ---------------------
 *  implements by majeed
 * ---------------------
 */
const commonService = require("../../../services/common.service");
import YearPicker from "../../global/year_picker";
import { preFix } from "../../../vuex/api";
import Axios from "axios";
export default {
  components: {
    YearPicker
  },
  props:['item'],
  data: () => ({
    label: "Select Overtime Year",
    valid: true,
    dialog: false,
    dialogEditForm: false,

    search: "",
    totalItems: 0,
    loading: true,
    formSchema: [
      {
        id: "",
        staff_id: "",
        staff_name:"",
        days:"",
        overtime: "",
        rate: "",
        total: "",
        year: "",
        month: "",
        isCheck: false
      }      
    ],
    staffData: [],
    months: [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December"
    ],
    SnackbarVal: {
      snackbar: false,
      color: "success",
      message: "",
    },
    selected: [],
    search: "",
    headers: [
      {
        text: "Name",
        align: "left",
        sortable: false,
        value: "name"
      },
      { text: "User Type", align: "left", value: "type_id" },
      { text: "Email", value: "email" }
    ],

    delete_id: "",
    row_index: "",
    dialog2: false,
    snackbar: false,
    color: "success",
    mode: "",
    timeout: 3000,
    left: "left",
    message: "",
    year: new Date().getFullYear().toString(),
    month: "",
    select: null,
    yearList: [],
    selected_year:'',
    typelist: [],

    isVisible: false,
    instituteShow: true,
    numberRules: [
     v => /^[1-9]\d*(\.\d+)?$/.test(v) || 'Input must be valid number'
    ],
    
  }),

  computed: {
    formTitle() {
      return this.formSchema[0].id > 0
        ? "Update Overtime for Outsourcing Staff"
        : "Add Overtime for Outsourcing Staff";
    },
     btnTitle() {
      return this.formSchema[0].id > 0
        ? "Update"
        : "Save";
    },
    showOvertimedata() {
      if (this.formSchema.year != null && this.formSchema.month != null)
        this.dialog = true;
      
    },
    getYears(){
          let year = new Date().getFullYear()
          let fetchYear = Array.from({length: year - 1900}, (value, index) => 2010 + index)
          fetchYear.forEach((item) => {
              this.yearList.push({year:item.toString(), name: item.toString()})
          })
    },

    rules(){
      const rules = []
      if(this.formSchema[v].isCheck){
          const rule =
        v => (v => !!v || ' is required')
        rules.push(rule)
      }
      return rules
    }
  },

  created() {},

  methods: {
    slNo(index){
      let sl = 1+index
       return sl;
    },
    validateBeforeSubmit(e) {
      
      var bigCities = this.formSchema.filter(function (e) {
              return e.isCheck == true;
          });
      if (this.$refs.form.validate()) {
        if (this.formSchema[0].id > 0) {
          commonService
            .updateFormData(this.formSchema, "overtime_info")
            .then(res => {
              if (res.status == 1) {
                 this.SnackbarVal.message = res.message;
      this.SnackbarVal.snackbar = true;
                location.reload()
              }
            });
        } else {
          commonService
            .insertFormData(bigCities, "overtime_info")
            .then(res => {
              if (res.status == 1) {
                this.SnackbarVal.message = res.message;
      this.SnackbarVal.snackbar = true;
                                location.reload()

              }
            });
        }
      }
    },
    setYear(selected_year) {
      this.year = selected_year;
    },
    getCheck() {
      if(this.formSchema[0].id > 0){

      }else{
         if (this.year && this.month) {
        this.getStuff();
        this.isVisible = true;
        }
      }
     
    },
    getStuff() {
      let year = this.year
      let month = this.month
      commonService.getAllData("outsource_staff").then(res => {
        let root = this;        
        root.formSchema = [];
        res.data.forEach(function(val) {
          root.formSchema.push({
            id: "",
            staff_id: val.id,
            staff_name: val.staff_name,
            overtime: "",
            rate: "80",
            total: "",
            year: year,
            month: month,
            isCheck: false
            
          });
        });

        this.staffData = res.data;

      
      });
    },
    checkIndex(event, index){
      
    },
reset(){ 
     if(this.formSchema[0].id > 0)
        {
          close(0)
        }else{
        this.$refs.form.reset();
        }
        },
    calculateTotal(index){
      if(this.formSchema[index].overtime  && this.formSchema[index].rate ){
          if(this.formSchema[index].overtime > 100) {
              return this.formSchema[index].total = parseFloat(this.formSchema[index].rate) * parseFloat(100)
          }else {
              return this.formSchema[index].total = parseFloat(this.formSchema[index].rate) * parseFloat(this.formSchema[index].overtime)
          }
        
      }
    }
  },

  watch: {
    // re-activity
    item(){
      this.staffData = []
      this.formSchema = []
       this.year = this.item.year
       this.month = this.item.month
      let id = this.item.id;
      let root = this;        
      
          root.formSchema.push({
            id: this.item.id,
            staff_id: this.item.staff_id,
            staff_name: this.item.staff_name,
            overtime: this.item.overtime,
            rate: this.item.rate,
            total: this.item.total,
            year: this.item.year,
            month: this.item.month,
            isCheck: true
            
          });

        this.staffData.push({
            id: this.item.id,
            staff_id: this.item.staff_id,
            staff_name: this.item.staff_name,
            overtime: this.item.overtime,
            rate: this.item.rate,
            total: this.item.total,
            year: this.item.year,
            month: this.item.month,
        });

        this.isVisible = true


    },
    year(){
      //  return this.year
       if(this.formSchema[0].id > 0){
           this.formSchema[0].year = this.year
       }
    }
  },

  mounted() {
    let year = new Date().getFullYear();
    this.getYears
  }
};
</script>

<style>
#mytable {
  font-family: arial, sans-serif;
  border-collapse: collapse;
  width: 100%;
}

#mytable td, #mytable th {
  border: 1px solid #dddddd;
  text-align: left;
  padding: 8px;
}

#mytable tr:nth-child(even) {
  background-color: #dddddd;
}
</style>



// WEBPACK FOOTER //
// src/components/administration/overtime_entry/overtime_entry_form.vue